import { getMenu, getMenuStatuses } from "@/components/layout/Navbar/api";

export const getMenuData = async () => {
  try {
    const res = await getMenu();
    if (!!res?.menus?.length) {
      const { menus } = res;
      return menus;
    }
    return [];
  } catch (e) {
    return [];
  }
};

/**
 * @returns {Promise<{ has_unsigned_any: boolean, has_open_employee_tasks: boolean } | null>}
 */
export const fetchMenuStatuses = async () => {
  try {
    const data = await getMenuStatuses();
    if (!data || data.status !== true) return null;
    return {
      has_unsigned_any: !!data.has_unsigned_any,
      has_open_employee_tasks: !!data.has_open_employee_tasks,
    };
  } catch (e) {
    return null;
  }
};

export const menuIcons = {
  setting: { viewBox: "0 0 18 18" },
  paper: { viewBox: "0 -2 17 17" },
  document: { viewBox: "0 0 12 16" },
  chart: { viewBox: "0 0 26 26" },
  mail_add: { viewBox: "2 1 18 18" },
  book: { viewBox: "2 1 18 18" },
  building: { viewBox: "0 0 20 20" },
  box_arrow: { viewBox: "0 0 20 20" },
  box: { viewBox: "0 0 20 20" },
  calendar_settings: { viewBox: "0 -2 18 18" },
  table_settings: { viewBox: "0 -2 18 18" },
  vehicle: { viewBox: "0 -2 18 18" },
};
